import { Helmet } from 'react-helmet-async';
import { DeliveryAreaListView } from 'src/sections/deliveryArea/view';

export default function DeliveryAreaListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Delivery Areas</title>
      </Helmet>

      <DeliveryAreaListView />
    </>
  );
}
